import React, { useContext } from "react";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import { iHistoryContext } from "../../../../../context/historyContext/interface";
import { useHistoryContext } from "../../../../../context/historyContext/historyContext";
import { iRecommendedTripContext } from "../../../../../context/recommendedTripContext/recommendedTripContextInterface";
import { useRecommendedTripContext } from "../../../../../context/recommendedTripContext/recommendedTripContext";
import { iSocketContext, useSocketContext } from "../../../../../context/socketContext/SocketContext";
import { useResetState } from "../../../../../utils/resetBookingData";
import { ScreenTypes } from "../../../../../enums";
import { DialogSelected } from "../../../../../constant/common";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { ROUTES } from "../../../../../constant";
import { consoleLog } from "../../../../../utils/consoleLog/consoleLog";
import { Logoutresponse } from "../../../../../interface";
import { logout } from "../../../../../api/authentication/authentication";
import { handleCustomError } from "../../../../../utils/handleCustomError";
import Cookies from "js-cookie";
import { environment } from "../../../../../constant/environment";
import { toastMessage } from "../../../../../helpers/toast/toastMessage";
import { Messages } from "../../../../../constant/messages/toastMessages";
import { getAccessTokenAPI } from "../../../../../api/config/getAccessToken";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { useNavigationUrl } from "../../../../../hooks/useNavigationUrl";
import { useNavigate } from "react-router-dom";
import { logoutClearStorage } from "../../../../../utils/logoutClearStorage";
import { rotateChatId } from "../../../../../utils/chat/rotateChatId";
import { SELECTED_CHAT_DATA } from "../../../../../constant/dummyData";

export function useDesktopSideBarLogic() {
  const state = useContext(StateContext);
  const {
    isOpenMobileSidebar,
    setenableMultiSelect,
    userInfo,
    setLoginCreateAccountState,
    setScreen,
    firstScreen,
    setFirstScreen,
    isMobile,
    setChatInputText,
    setChatData,
    setSelectedChatData,
    setViewPreference,
    setIsFetchingMobileAirports,
    accessJWT,
    setIsValidAccessToken,
    setNav,
    setStartingValue,
    setDestValue,
    setClimate,
    setPopulation,
    setExperience,
    setAccomodations,
    setFoodPreferences,
    setMonths,
    setSelectedDestFlag,
    setTripForNDays,
    setIsLoggedIn,
    setBudget,
    setUserInfo,
    setAccessJWT,
    setIsAdminChat,
    setOnBoardingStep,
    promoCode,
    setPromoCode,
    setUtmParams,
  }: iGlobalContext = state;

  const { resetTranscript } = useSpeechRecognition();
  const { getHistory, setCurrentHistoryId }: iHistoryContext = useHistoryContext();
  const { handleCancel, setDisableInput }: iRecommendedTripContext = useRecommendedTripContext();
  const { handleCloseSocketConnection }: iSocketContext = useSocketContext();
  const navigate = useNavigate();
  const { navigateWithParams } = useNavigationUrl();
  const resetState = useResetState();

  const toggleSidebar = () => {
    if (!isOpenMobileSidebar) {
      triggerGAEvent(GA_LABEL_ENUMS.home_side_bar_open_click);
      getHistory(true, true);
    }
    if (!isMobile) {
      navigateWithParams(ROUTES.Home);
      return;
    }
  };

  const handleNav = async () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    try {
      handleCloseSocketConnection();
      handleCancel();
      setChatData([]);
      setDisableInput(false);
      // Fresh conversation → fresh chat id so the backend loads an empty
      // TripContext (else a bare "Hi" re-runs the previous chat's search).
      rotateChatId();
      setSelectedChatData({ ...SELECTED_CHAT_DATA });
      await resetState();
      setChatInputText("");
      navigateWithParams(ROUTES.Home);
      setScreen("");
      setFirstScreen(ScreenTypes.NewTrip);
    } catch (error) {
      console.error("Error during navigation:", error);
    }
  };

  const handleMobNav = async () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    try {
      setChatData([]);
      setDisableInput(false);
      handleCloseSocketConnection();
      handleCancel();
      setChatInputText("");
      // Fresh conversation → fresh chat id (see handleNav for rationale).
      rotateChatId();
      setSelectedChatData({ ...SELECTED_CHAT_DATA });
      await resetState();
      setenableMultiSelect(false);
      resetState();
      setTimeout(() => navigateWithParams(ROUTES.NewTrip), 100);
    } catch (error) {
      console.error("Error during navigation:", error);
    }
  };

  const handleEditPreference = () => {
    if (!isMobile && firstScreen === ScreenTypes.newPreferences && window.location.pathname === ROUTES.Home) return;
    if (isMobile && window.location.pathname === ROUTES.preferences) return;
    if (!isMobile) setScreen("");
    isMobile ? navigateWithParams(ROUTES.preferences) : setFirstScreen(ScreenTypes.newPreferences);
    if (!isMobile && window.location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    triggerGAEvent(GA_LABEL_ENUMS.home_preferences_click);
    setIsFetchingMobileAirports(true);
    setViewPreference(true);
  };

  const handleMyTrips = () => {
    triggerGAEvent(GA_LABEL_ENUMS.My_trips_click);
    isMobile ? navigateWithParams(ROUTES.MyTrips) : setFirstScreen(ScreenTypes.MyTrips);
    setScreen("");
  };

  const handleHistory = () => {
    if (firstScreen !== ScreenTypes.History) getHistory(true, true);
    triggerGAEvent(GA_LABEL_ENUMS.History_click);
    isMobile ? navigateWithParams(ROUTES.History) : setFirstScreen(ScreenTypes.History);
    setScreen("");
  };

  const handleSavedTrip = () => {
    triggerGAEvent(GA_LABEL_ENUMS.saved_trips_click);
    isMobile ? navigateWithParams(ROUTES.SavedTrip) : setFirstScreen(ScreenTypes.SavedTrip);
    setScreen("");
  };

  const handleProfile = () => {
    triggerGAEvent(GA_LABEL_ENUMS.home_edit_profile_click);
    setLoginCreateAccountState({ flag: true, page: DialogSelected.EDIT_ACCOUNT });
  };

  const handleSupport = () => {
    triggerGAEvent(GA_LABEL_ENUMS.sidebar_contact_us);
    setLoginCreateAccountState({ flag: true, page: DialogSelected.GET_HELP });
    setScreen("");
  };

  const handlePrivacyPolicy = () => {
    triggerGAEvent(GA_LABEL_ENUMS.Privacy_polcy_click);
    if (isMobile) {
      navigateWithParams(ROUTES.PrivacyPolicy);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.privacyPolicy);
      if (window.location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };

  const handleTermsAndCondtions = () => {
    triggerGAEvent(GA_LABEL_ENUMS.Terms_of_service_click);
    if (isMobile) {
      navigateWithParams(ROUTES.Tos);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.termsOfUse);
      if (window.location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };

  function resetStateValues(setters: React.Dispatch<React.SetStateAction<any[]>>[]) {
    setters.forEach((setter) => setter([]));
  }

  function resetAppState() {
    setScreen("");
    setFirstScreen("");
    window.localStorage.removeItem("_zenvoya_JWT");
    const resetUserInfo = {
      id: "",
      name: "",
      email: "",
      phone: "",
      profile_pic: "",
      loggedIn: false,
      role: 0,
    };
    [setUserInfo].forEach((setFunc) => setFunc(resetUserInfo));
    setIsLoggedIn(false);
    setNav("LANDING_PAGE");
    setSelectedDestFlag(false);
    setStartingValue({ value: "", flag: false });
    setDestValue({ value: "", flag: false });
    resetStateValues([
      setClimate,
      setPopulation,
      setExperience,
      setFoodPreferences,
      setAccomodations,
      setMonths,
      setBudget,
      setTripForNDays,
    ]);
  }

  function postLogoutMessage() {
    const iframe = document.querySelector("#app_domain") as HTMLIFrameElement | null;
    const wind = iframe?.contentWindow;
    wind?.postMessage(JSON.stringify({}), "*");
    if (window && window.parent) {
      window.parent.postMessage(JSON.stringify({ action: "logout", data: {} }));
    }
  }

  async function getAccessToken() {
    let success = false;
    let count = 0;
    while (!success) {
      count++;
      const response = await getAccessTokenAPI();
      if (response?.statusCode === 200 && response?.data) {
        setAccessJWT(response?.data);
        success = true;
      }
      if (count > 4) break;
    }
  }

  async function handleLogoutClick() {
    try {
      const nativeElement = document.getElementById("deviceID") as HTMLInputElement | null;
      setOnBoardingStep("lookingFor");
      if (nativeElement?.value) {
        consoleLog(["LOG OUT VALUE", nativeElement?.value]);
        const response: Logoutresponse = await logout(accessJWT, {
          userId: userInfo?.id,
          deviceId: nativeElement?.value ?? "",
        });
        if (response?.statusCode !== 200) {
          handleCustomError(response?.statusCode, "user.logout");
          return null;
        }
      }
      Cookies.remove(`${environment}userData`, { path: "/", domain: ".zenvoya.ai" });
      toastMessage.success(Messages["logout.success"].messageTitle, Messages["logout.success"].message);
      resetAppState();
      logoutClearStorage();
      setUtmParams("");
      navigate(ROUTES.onBoarding);
      triggerGAEvent(GA_LABEL_ENUMS.Logout);
      postLogoutMessage();
      setIsValidAccessToken(false);
      setPromoCode([]);
      await getAccessToken();
    } catch (error) {
      console.error("Error during logout:", error);
      toastMessage.error(Messages["loggout.failure.message"].messageTitle, Messages["loggout.failure.message"].message);
    }
  }

  const handleSelect = (value: string) => {
    switch (value) {
      case "Profile":
        handleProfile();
        break;
      case "My Trips":
        handleMyTrips();
        break;
      case "Saved":
        handleSavedTrip();
        break;
      case "History":
        handleHistory();
        break;
      case "Preferences":
        handleEditPreference();
        break;
      case "Support":
        handleSupport();
        break;
      case "Privacy Policy":
        handlePrivacyPolicy();
        break;
      case "Terms of Service":
        handleTermsAndCondtions();
        break;
      case "Log out":
        handleLogoutClick();
        break;
      default:
        console.warn("Unknown option selected:", value);
    }
  };

  return {
    userInfo,
    firstScreen,
    isMobile,
    promoCode,
    setCurrentHistoryId,
    setIsAdminChat,
    toggleSidebar,
    handleNav,
    handleMobNav,
    handleSelect,
  };
}
